import { FormContext } from '../formManager/formContext';
import { TextInput } from '@interstate/components/TextInput';
import { useContext, useEffect, useMemo, useState } from 'react';
import type { FormStockInputProps } from '../types';
import type { InterstateOnChangeEvent } from '@interstate/components/InterstateEvents';
import { dealLockHooks } from '../../hooks';

const NOT_ALLOWED_CHARACTERS = /[^a-zA-Z0-9]/g;
const MAX_EDITABLE_STOCK_NUMBER_LENGTH = 30;

const formatValue = (value: string) => value.replace(NOT_ALLOWED_CHARACTERS, '').toUpperCase();

export const FormStockInput = ({ name, label }: FormStockInputProps) => {
    const { changeHandler, form } = useContext(FormContext);
    const [inputValue, setInputValue] = useState((form.values[name] as string) || '');
    const formattedValue = useMemo(() => formatValue(inputValue), [inputValue]);

    const isLocked = dealLockHooks.useIsDealLocked();

    useEffect(() => {
        setInputValue(formattedValue.slice(0, MAX_EDITABLE_STOCK_NUMBER_LENGTH));
    }, [inputValue]);

    const handleChange = (event: InterstateOnChangeEvent<string>) => {
        const newValue = event.target.value;
        const newFormattedValue = formatValue(newValue);
        const truncatedValue = newFormattedValue.slice(0, MAX_EDITABLE_STOCK_NUMBER_LENGTH);
        setInputValue(newValue);
        changeHandler(name, truncatedValue);
        delete form.error[name];
    };

    return (
        <TextInput
            value={inputValue}
            data-testid={'vehicle-input-' + name}
            label={label}
            disabled={isLocked}
            id={name}
            key={name}
            name={name}
            hasError={Boolean(form.error[name])}
            errorMessage={form.error[name]}
            onChange={handleChange}
            sx={{ mt: 1, pb: 0.5 }}
        />
    );
};
